export default __webpack_public_path__ + "ad907996d7dc5ce8b09bd834884eb482.png";